import { Phone } from "lucide-react";
import { Link } from "react-router-dom";
import zenithLogo from "@/assets/zenith-logo.webp";

const FooterSection = () => (
  <>
    {/* Sticky phone bar (mobile) — job calls */}
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-primary text-primary-foreground">
      <a href="tel:5056048536" className="flex items-center justify-center gap-2 py-3 font-bold text-sm">
        <Phone className="h-4 w-4" /> Call Now (505) 264-0170
      </a>
    </div>

    <footer className="bg-foreground text-white/80 pt-12 pb-20 md:pb-12 border-t border-white/10" role="contentinfo">
      <div className="container mx-auto max-w-6xl px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <img
              src={zenithLogo}
              alt="Zenith Solutions - Albuquerque Roofing Company"
              className="h-10 mb-3 brightness-0 invert"
              width={118}
              height={40}
              loading="lazy"
            />
            <p className="text-sm leading-relaxed text-white/60">
              Albuquerque's trusted roofing contractor, solar installer, and home construction company. Licensed,
              insured, A+ BBB rated.
            </p>
          </div>
          <div>
            <p className="font-bold text-white mb-3 text-sm uppercase tracking-widest">Services</p>
            <nav aria-label="Services navigation" className="space-y-2 text-sm">
              <Link to="/services/roofing" className="block hover:text-white transition-colors">
                Roofing
              </Link>
              <Link to="/services/construction" className="block hover:text-white transition-colors">
                General Construction
              </Link>
              <Link to="/services/solar" className="block hover:text-white transition-colors">
                Solar Installation
              </Link>
              <Link to="/services/mold-remediation" className="block hover:text-white transition-colors">
                Mold & Water Mitigation
              </Link>
            </nav>
          </div>
          <div>
            <p className="font-bold text-white mb-3 text-sm uppercase tracking-widest">Tools & Links</p>
            <nav aria-label="Footer navigation" className="space-y-2 text-sm">
              <Link to="/tools/design-eyeq" className="block hover:text-white transition-colors">
                Design EyeQ® Visualizer
              </Link>
              <Link to="/tools/solar-calculator" className="block hover:text-white transition-colors">
                Solar Savings Calculator
              </Link>
              <Link to="/tools" className="block hover:text-white transition-colors">
                All Homeowner Tools
              </Link>
              <Link to="/get-estimate" className="block hover:text-white transition-colors">
                Free Estimate
              </Link>
            </nav>
          </div>
          <div>
            <p className="font-bold text-white mb-3 text-sm uppercase tracking-widest">Contact</p>
            <address className="not-italic space-y-2 text-sm">
              <p>
                <a href="tel:5056048536" className="hover:text-white transition-colors">
                  Jobs: (505) 264-0170
                </a>
              </p>
              <p>
                <a href="tel:5056048536" className="hover:text-white transition-colors">
                  Office: (505) 604-8536
                </a>
              </p>
              <p>
                <a href="mailto:info@zenithsolutionsnm.com" className="hover:text-white transition-colors">
                  info@zenithsolutionsnm.com
                </a>
              </p>
              <p>Albuquerque, NM 87101</p>
            </address>
            <p className="text-xs text-white/60 mt-4">
              Serving Albuquerque, Rio Rancho, Corrales, Los Lunas, Bernalillo, Santa Fe & all of Central NM
            </p>
          </div>
        </div>
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/60">
          <p>©2026 Zenith Solutions LLC. All rights reserved. Licensed & Insured in New Mexico.</p>
          <p>
            Designed by <span className="text-white/60 font-medium">Clowd Marketing</span>
          </p>
          <div className="flex gap-4">
            <Link to="/privacy-policy" className="hover:text-white/60 transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" className="hover:text-white/60 transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  </>
);

export default FooterSection;
